export default {
  automotive: {
    header: 'Dealership',
    menu: {
      profile: 'Dashboard',
      customers: {
        customers: 'Customers',
        list: 'All',
        sources: 'Sources',
      },
      audiences: {
        audiences: 'Audiences',
        tag: 'Tag',
        programmatic: 'Programmatic',
        custom: 'Custom',
      },
      inventory: {
        inventory: 'Inventory',
        overview: 'Overview',
        list: 'Feed',
        marketed: 'Marketed',
        sold: 'Sold',
      },
      campaigns: {
        campaigns: 'Campaigns',
        managed: 'Managed',
        selfService: 'Self Service',
        monthOverMonth: 'Month over Month',
      },
      reports: {
        reports: 'Reports',
        conversions: 'Conversions',
        performance: 'Performance',
        polk: 'Polk',
        conversionPaths: 'Path to Conversion',
        creatives: 'Creatives',
        salePaths: 'Path to sales',
        ga4: 'GA4',
      },
    },
  },
  retail: {
    header: 'Account',
    menu: {
      profile: 'Dashboard',
      customers: {
        customers: 'Customers',
        list: 'All',
        sources: 'Sources',
      },
      audiences: {
        audiences: 'Audiences',
        tag: 'Tag',
        programmatic: 'Programmatic',
        custom: 'Custom',
      },
      campaigns: {
        campaigns: 'Campaigns',
        managed: 'Managed',
        selfService: 'Self Service',
        monthOverMonth: 'Month over Month',
      },
      reports: {
        reports: 'Reports',
        conversions: 'Conversions',
        performance: 'Performance',
        polk: 'Polk',
        conversionPaths: 'Path to Conversion',
        creatives: 'Creatives',
        salePaths: 'Path to sales',
        ga4: 'GA4',
      },
    },
  },
}
